
import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();

  const handleCitizenReporter = () => {
    navigate('/citizen-submission');
  };

  return (
    <section className="relative min-h-screen bg-red-600 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-32 h-32 border-2 border-white/20 rounded-full"></div>
        <div className="absolute top-40 right-32 w-24 h-24 border border-white/15 rotate-45"></div>
        <div className="absolute bottom-32 left-1/4 w-16 h-16 border border-white/20 rounded-full"></div>
      </div>

      <div className="relative z-10 container mx-auto px-6 py-20 flex flex-col items-center justify-center min-h-screen text-center">
        {/* Logo */}
        <div className="mb-8">
          <img 
            src="https://static.readdy.ai/image/6e6f586929bab4b45ad1bd9812f7687b/c0b063b12084b2579388308d42ec49b7.png"
            alt="Somukoi Logo"
            className="h-20 md:h-24 mx-auto mb-4"
          />
          <div className="w-24 h-1 bg-white/60 mx-auto"></div>
        </div>

        {/* Main Tagline */}
        <h2 className="text-3xl md:text-5xl font-semibold text-white mb-6 leading-tight">
          Voices of the People.<br />
          Stories of the Northeast.
        </h2>

        {/* Subheading */}
        <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl leading-relaxed">
          Empowering communities through stories, ideas, and real voices.
        </p>

        {/* CTA Button */}
        <div className="flex flex-col sm:flex-row gap-6 mb-16">
          <button 
            onClick={handleCitizenReporter}
            className="border-2 border-white text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-white hover:text-red-700 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer flex items-center gap-3"
          >
            <i className="ri-mic-line text-xl"></i>
            Become a Citizen Reporter
          </button>
        </div>

        {/* Cultural Icons */}
        <div className="flex items-center gap-8 text-white/70">
          <div className="flex items-center gap-2">
            <i className="ri-community-line text-2xl"></i>
            <span className="text-sm">Communities</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-palette-line text-2xl"></i>
            <span className="text-sm">Culture</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-lightbulb-line text-2xl"></i>
            <span className="text-sm">Innovation</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/60 animate-bounce">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
}
